function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
export const IconButton = {
    MuiIconButton: {
        defaultProps: {
            disableFocusRipple: true
        },
        styleOverrides: {
            root: ({ theme })=>({
                    color: "#000000de",
                    ["&:hover"]: {
                        color: theme.palette.primary.main,
                        background: "000000"
                    },
                    ["&:focus-visible"]: {
                        color: theme.palette.primary.main,
                        background: "#FFEBD2"
                    }
                })
        },
        variants: [
            {
                props: {
                    size: "xsmall"
                },
                style: ({ theme })=>_object_spread({
                        height: "36px",
                        width: "36px"
                    }, theme.typography.textSm)
            },
            {
                props: {
                    size: "2xsmall"
                },
                style: ({ theme })=>_object_spread({
                        height: "32px",
                        width: "32px"
                    }, theme.typography.textSm)
            }
        ]
    }
};

//# sourceMappingURL=IconButton.js.map